<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="handleAdd()"
          >新增</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleBatchDel()"
          >删除</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleDel(scope.row.id)"
          >删除</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="nameForm"
        >
          <el-input
            v-model="showName"
            disabled
            placeholder=""
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="mobileForm"
        >
          <el-input
            v-model="inputMobile"
            maxlength="11"
            :disabled="isdisabledFn"
            placeholder="请输入账号"
          ></el-input>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ceilingOption } from "@/const/salesCloud/ceilingOption";
import {
  findceilingList,
  setCeiling,
  editCeiling,
  delCeiling,
} from "@/api/salesCloud/ceiling";
import { getUser } from "@/api/salesCloud/bindEngineer";
export default {
  name: "bank",
  components: {},
  data() {
    return {
      tableOption: ceilingOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      inputMobile: "",
      showName: "",
      userId: "",
      isdisabledFn: false,
    };
  },
  created() {
    this.handleList();
  },
  watch: {
    inputMobile(newMobile) {
      if (newMobile == "" || this.isdisabledFn) {
        return;
      }
      if (newMobile.length == 11) {
        let params = {};
        params.mobile = newMobile;
        if (newMobile.length == 11) {
          this.$refs.crud.$refs.tableForm.form.mobile = newMobile;
        } else {
          this.$refs.crud.$refs.tableForm.form.mobile = "";
        }
        getUser(params).then((res) => {
          if (res.code == "200") {
            let data = JSON.parse(res.data);
            console.log(data);
            this.$message({
              showClose: false,
              // message: data[0].realName,
              duration: 1,
              type: "success",
            });
            this.$nextTick(() => {
              this.showName = data.realName;
              this.userId = data.id;
              console.log(this.showName);
            });
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            setTimeout(() => {
              this.$refs.crud.$refs.tableForm.form.mobile = "";
            }, 1000);
          }
        });
      } else {
        this.$refs.crud.$refs.tableForm.form.mobile = "";
      }
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findceilingList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findceilingList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findceilingList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findceilingList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.clean();
      this.showName = row.name;
      this.inputMobile = row.mobile;
      this.isdisabledFn = true;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      findceilingList(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row.ceiling);
      let txt = "";
      let flag = false;
      if (
        !/^[1-9]\d*$/.test(
          row.integralValue
        )
      ) {
        txt = "请输入正确的积分上限";
        flag = true;
      }
      if (
        !/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
          row.ceiling
        )
      ) {
        txt = "请输入正确的金额上限";
        flag = true;
      }
      if (this.user == "") {
        txt = "请确定该用户是否存在";
        flag = true;
      }
      if (flag) {
        this.$message({
          showClose: true,
          message: txt,
          type: "error",
        });
        done();
        this.$refs.crud.rowAdd();
        return;
      }
      let obj = {};
      obj.userId = this.userId;
      obj.ceiling = row.ceiling;
      obj.integralValue = row.integralValue;
      setCeiling(obj)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
            done();
            this.$refs.crud.rowAdd();
            return;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    clean() {
      this.inputMobile = "";
      this.showName = "";
      this.userId = "";
      this.isdisabledFn = false;
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(id) {
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCeiling(id)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据批量删除
     *
     **/
    handleBatchDel() {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          delCeiling(ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      let txt = "";
      let flag = false;
      console.log(row.integralValue);
      if (
        !/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
          row.ceiling
        )
      ) {
        txt = "请输入正确的金额上限";
        flag = true;
      }
      if (
        !/^[1-9]\d*$/.test(
          row.integralValue
        )
      ) {
        txt = "请输入正确的积分上限";
        flag = true;
      }
      if (flag) {
        this.$message({
          showClose: true,
          message: txt,
          type: "error",
        });
        done();
        this.$refs.crud.rowAdd();
        return;
      }
      let obj = {};
      obj.id = row.id;
      obj.ceiling = row.ceiling;
      obj.integralValue = row.integralValue;
      editCeiling(obj)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
            done();
            this.$refs.crud.rowAdd();
            return;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
  },
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
